import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { saveAnalytics, fetchSavedAnalytics } from '@/redux/rtk/features/CRM/analytics/analyticsSlice';

const CreatePageModal = ({ visible, onClose }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const pageData = {
                name: values.name,
                description: 'User created analytics page',
                dataSource: 'system', // System type for pages
                chartType: 'page_definition', // Special type to identify this as a page/tab
                chartConfig: {},
                filters: {},
                isTemplate: false,
                isPublic: false,
                displayOrder: 0,
            };

            await dispatch(saveAnalytics(pageData)).unwrap();
            message.success(t('analytics.pageCreatedSuccess'));
            dispatch(fetchSavedAnalytics({ includePublic: true }));
            form.resetFields();
            onClose();
        } catch (error) {
            console.error('Failed to create page:', error);
            message.error(t('analytics.pageCreateFailed'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={t('analytics.createNewPage')}
            open={visible}
            onCancel={onClose}
            footer={null}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    name="name"
                    label={t('analytics.pageName')}
                    rules={[{ required: true, message: t('analytics.pageNamePlaceholder') }]}
                >
                    <Input placeholder={t('analytics.pageNamePlaceholder')} />
                </Form.Item>

                <Form.Item>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <Button onClick={onClose}>{t('common.cancel')}</Button>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            {t('analytics.createPage')}
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CreatePageModal;
